import hero480Avif from "@/assets/optimized/hero-480.avif";
import hero768Avif from "@/assets/optimized/hero-768.avif";
import hero1280Avif from "@/assets/optimized/hero-1280.avif";
import hero480Webp from "@/assets/optimized/hero-480.webp";
import hero768Webp from "@/assets/optimized/hero-768.webp";
import hero1280Webp from "@/assets/optimized/hero-1280.webp";

import truck400Avif from "@/assets/optimized/truck-400.avif";
import truck800Avif from "@/assets/optimized/truck-800.avif";
import truck1200Avif from "@/assets/optimized/truck-1200.avif";
import truck400Webp from "@/assets/optimized/truck-400.webp";
import truck800Webp from "@/assets/optimized/truck-800.webp";
import truck1200Webp from "@/assets/optimized/truck-1200.webp";

import logo112Webp from "@/assets/optimized/logo-112.webp";
import logo168Webp from "@/assets/optimized/logo-168.webp";

export const heroImage = {
  // Same URL as the LCP preload so the request can start from <head>.
  src: hero1280Avif,
  width: 1373,
  height: 1146,
  sizes: "100vw",
  sources: [
    {
      type: "image/avif",
      srcSet: `${hero480Avif} 480w, ${hero768Avif} 768w, ${hero1280Avif} 1280w`,
    },
    {
      type: "image/webp",
      srcSet: `${hero480Webp} 480w, ${hero768Webp} 768w, ${hero1280Webp} 1280w`,
    },
  ],
};

export const truckImage = {
  src: truck800Avif,
  width: 1440,
  height: 1920,
  sizes: "(min-width: 1024px) 36rem, 100vw",
  sources: [
    {
      type: "image/avif",
      srcSet: `${truck400Avif} 400w, ${truck800Avif} 800w, ${truck1200Avif} 1200w`,
    },
    {
      type: "image/webp",
      srcSet: `${truck400Webp} 400w, ${truck800Webp} 800w, ${truck1200Webp} 1200w`,
    },
  ],
};

export const logoImage = {
  src: logo112Webp,
  width: 112,
  height: 112,
  sizes: "56px",
  sources: [
    {
      type: "image/webp",
      srcSet: `${logo112Webp} 112w, ${logo168Webp} 168w`,
    },
  ],
};

// Lighthouse mobile is ~412 CSS px at 2.625 DPR (~1082 px). That selects 1280w.
export const heroPreload = {
  href: hero1280Avif,
  imageSrcSet: `${hero480Avif} 480w, ${hero768Avif} 768w, ${hero1280Avif} 1280w`,
  imageSizes: "100vw",
  type: "image/avif",
};
